import { ApiResponse, useRequest } from "./request.hooks";

export const useTiktokAdvertiserService = () => {
    const { request } = useRequest();

    const upsertAdvertiserToSellerAccounts = (payload: {
        advertiserId: number;
        tiktokSellerAccountIds: number[];
    }): Promise<ApiResponse> => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(
                    request({
                        url: "/api/v1/tiktokAdvertiser/actions/upsertAdvertiserToSellerAccounts",
                        method: "POST",
                        headers: {
                            "content-type": "application/json",
                        },
                        data: payload
                    })
                );
            }, 500);
        });
    };

    return {
        upsertAdvertiserToSellerAccounts
    };
};

